import { Typography } from '@mui/material';

export function CrimeOfficer({ officer }) {
  return (
    <Typography variant="caption">
      {`Name: ${officer?.firstName}  ${officer?.surname}, Team: ${officer.team},  Attendance status: ${officer.classificatioDescription}`}
    </Typography>
  );
}
